import dateUtil from './dateTime';
import appointmentUtil from './appointment';
import store from './../store';

/* eslint-disable max-len */

/* ============
 * Time Slot Util
 * ============
 */

const moment = require('moment-timezone');

const slotSize = 30; // minutes for each separate slot

function setTimeToMoment(timeStr, dateMoment) {
  dateMoment.hours(Number(timeStr.substring(0, 2)));
  dateMoment.minutes(Number(timeStr.substring(3, 5)));
  dateMoment.seconds(0);
  dateMoment.milliseconds(0);
}

function addSlotObjToSlotArray(slot, slotArr) {
  let isNew = true;
  for (let i = 0; i < slotArr.length; i += 1) {
    if (slotArr[i].time === slot.time) {
      for (let prvIdx = 0; prvIdx < slot.providers.length; prvIdx += 1) {
        if (slotArr[i].providers.indexOf(slot.providers[prvIdx]) < 0) {
          slotArr[i].providers.push(slot.providers[prvIdx]);
        }
      }
      isNew = false;
      break;
    }
  }
  if (isNew) {
    slotArr.push(slot);
  }
}

function addAvailableSlots(slotsA, slotsB) {
  const retval = {};
  Object.keys(slotsA).forEach((dateKey) => {
    retval[dateKey] = slotsA[dateKey].slice();
  });
  Object.keys(slotsB).forEach((dateKey) => {
    const slotArrB = slotsB[dateKey].slice();
    if (retval[dateKey]) {
      slotArrB.forEach((slot) => {
        addSlotObjToSlotArray(slot, retval[dateKey]);
      });
    } else {
      retval[dateKey] = slotArrB;
    }
  });
  return retval;
}

function makeTimeSlotsFromPeriodArray(periodArr, id, timezone) {
  if (!periodArr) {
    return {};
  }
  const retval = {};
  for (let i = 0; i < periodArr.length; i += 1) {
    const period = periodArr[i];
    const start = moment.tz(period.start, timezone);
    let end;
    if (period.end) {
      end = moment.tz(period.end, timezone);
    } else {
      end = moment.tz(timezone);
      end.hours(0);
      end.minutes(0);
      end.seconds(0);
      end.milliseconds(0);
      end.add(2, 'months');
    }
    const dateItr = moment.tz(start, timezone);
    while (dateItr.isSameOrBefore(end, 'day')) {
      const dayOfWeek = dateUtil.dayOfWeekKeyForMoment(dateItr);
      let slotArr = [];
      const dateKey = dateItr.format('YMMDD');
      if (retval[dateKey]) {
        slotArr = retval[dateKey];
      }
      if (period[dayOfWeek]) {
        const dayPeriodArr = period[dayOfWeek];

        dayPeriodArr.forEach((dayPeriod) => {
          const startTime = moment.tz(dateItr, timezone);
          setTimeToMoment(dayPeriod.start, startTime);
          const endTime = moment.tz(dateItr, timezone);
          setTimeToMoment(dayPeriod.end, endTime);

          // is start date
          if (dateItr.isSame(start, 'day') && startTime.format('HH:mm').localeCompare(start.format('HH:mm')) < 0) {
            startTime.hours(start.hours());
            startTime.minutes(start.minutes());
          }

          // is end date
          if (dateItr.isSame(end, 'day') && endTime.format('HH:mm').localeCompare(end.format('HH:mm')) > 0) {
            endTime.hours(end.hours());
            endTime.minutes(end.minutes());
          }

          const timeItr = moment.tz(startTime, timezone);
          while (timeItr.diff(endTime) < 0) {
            const slot = {
              time: timeItr.format('HH:mm'),
              providers: [id],
              durationLeft: slotSize,
            };
            addSlotObjToSlotArray(slot, slotArr);
            timeItr.add(slotSize, 'minutes');
          }
        });

        if (slotArr.length > 0) {
          retval[dateKey] = slotArr;
        }
      }
      dateItr.add(1, 'days');
    }
  }
  return retval;
}

function subtractTimeSlots(openingSlots, dayoffSlots) {
  const retval = {};
  Object.keys(openingSlots).forEach((dateKey) => {
    const openingSlotArr = openingSlots[dateKey];
    if (dayoffSlots[dateKey]) {
      const dayoffSlotArr = dayoffSlots[dateKey];

      // const filteredSlotArr = openingSlotArr.filter(obj =>
      //   !dayoffSlotArr.some(dayoffSlot => dayoffSlot.time === obj.time)
      // );

      openingSlotArr.forEach((openingSlot) => {
        dayoffSlotArr.forEach((dayOffSlot) => {
          if (openingSlot.time === dayOffSlot.time) {
            openingSlot.durationLeft -= dayOffSlot.durationLeft;
          }
        });
      });

      const filteredSlotArr = openingSlotArr.filter((obj) => obj.durationLeft > 0);

      retval[dateKey] = filteredSlotArr.slice();
    } else {
      retval[dateKey] = openingSlotArr.slice();
    }
  });
  return retval;
}

function overlappedTimeSlots(openingSlots, dayoffSlots) {
  const retval = {};
  Object.keys(openingSlots).forEach((dateKey) => {
    const openingSlotArr = openingSlots[dateKey];
    if (dayoffSlots[dateKey]) {
      const dayoffSlotArr = dayoffSlots[dateKey];
      const filteredSlotArr = openingSlotArr.filter((obj) =>
        dayoffSlotArr.some((dayoffSlot) => dayoffSlot.time === obj.time)
      );
      retval[dateKey] = filteredSlotArr.slice();
    }
  });
  return retval;
}

function makeTimeSlotsFromAppointments(appointments, id, timezone) {
  const retval = {};
  appointments.forEach((appointment) => {
    if (appointment.status !== 'cancelled') {
      const appointmentMoment = moment.tz(appointment.due, timezone);
      let visitDuration = appointmentUtil.visitDuration(appointment);
      while (visitDuration > 0) {
        const slot = {
          time: appointmentMoment.format('HH:mm'),
          providers: [id],
          durationLeft: Math.min(slotSize, visitDuration),
        };
        const dateKey = appointmentMoment.format('YMMDD');
        if (!retval[dateKey]) {
          retval[dateKey] = [];
        }
        const slotArr = retval[dateKey];
        let isNew = true;
        for (let i = 0; i < slotArr.length; i += 1) {
          if (slotArr[i].time === slot.time) {
            slotArr[i].durationLeft += slot.durationLeft;
            isNew = false;
            break;
          }
        }
        if (isNew) {
          slotArr.push(slot);
        }
        // addSlotObjToSlotArray(slot, retval[dateKey]);
        visitDuration -= slotSize;
        appointmentMoment.add(slotSize, 'minutes');
      }
    }
  });
  return retval;
}

function dateKeyToDateStr(dateKey) {
  const year = dateKey.substring(0, 4);
  const month = dateKey.substring(4, 6);
  const date = dateKey.substring(6, 8);
  return `${year}-${month}-${date}`;
}

function localTimeZone() {
  // let savedTimeZone = localStorage.getItem('timezone');
  let savedTimeZone = '';
  const user = store.state.auth.user;
  if (user) {
    savedTimeZone = user.timezone;
  }
  if (!savedTimeZone) {
    savedTimeZone = moment.tz.guess();
  }
  return savedTimeZone;
}

function makeTimeSlotsFromOpeningHoursMinusDayOff(providerProfile, timeZone) {
  if (!providerProfile.opening) {
    return {};
  }
  const openingSlots = makeTimeSlotsFromPeriodArray(providerProfile.opening, providerProfile.id, timeZone);
  // console.log(openingSlots);
  const dayoffSlots = makeTimeSlotsFromPeriodArray(providerProfile.dayoff, providerProfile.id, timeZone);
  // console.log(dayoffSlots);
  return subtractTimeSlots(openingSlots, dayoffSlots);
}

export default {
  getSlotSize() {
    return slotSize;
  },

  convertTimeString(timeStr, format = 'Y-MM-DD HH:mm:ss', fromTimezone = 'UTC', toTimezone = null) {
    if (!fromTimezone) {
      fromTimezone = 'UTC';
    }
    if (!toTimezone) {
      toTimezone = localTimeZone();
    }
    const fromMoment = moment.tz(timeStr, fromTimezone);
    const toMoment = moment.tz(fromMoment.unix() * 1000, toTimezone);
    return toMoment.format(format);
  },

  getOverlappedOpeningAndDayOff(providerProfile, timeZone) {
    const openingSlots = makeTimeSlotsFromPeriodArray(providerProfile.opening, providerProfile.id, timeZone);
    const dayOffSlots = makeTimeSlotsFromPeriodArray(providerProfile.dayoff, providerProfile.id, timeZone);
    return overlappedTimeSlots(openingSlots, dayOffSlots);
  },

  getOpeningHoursMinusDayOff(providerProfile, timeZone) {
    return makeTimeSlotsFromOpeningHoursMinusDayOff(providerProfile, timeZone);
  },

  extractSlotsFromPeriodArray(periodArr, id, timezone) {
    return makeTimeSlotsFromPeriodArray(periodArr, id, timezone);
  },

  getAvailableSlotsWithDuration(schedule, duration, timezone) {
    const returnValue = {};
    Object.keys(schedule).forEach((dateKey) => {
      const dateStr = dateKeyToDateStr(dateKey);
      returnValue[dateKey] = schedule[dateKey].filter((slot) => {
        const slotMoment = moment.tz(`${dateStr} ${slot.time}`, timezone);
        const nextSlotMoment = slotMoment.clone();
        let remainingDuration = duration;
        remainingDuration -= slot.durationLeft;
        // remainingDuration -= slotSize;
        if (remainingDuration > 0 && slot.durationLeft < slotSize) {
          return false;
        }
        while (remainingDuration > 0) {
          nextSlotMoment.add(slotSize, 'minutes');
          const nextSlotDateKey = nextSlotMoment.format('YMMDD');
          let hasNextSlot = null;
          if (schedule[nextSlotDateKey]) {
            const nextSlot = schedule[nextSlotDateKey].find((s) => s.time === nextSlotMoment.format('HH:mm'));
            hasNextSlot = !!nextSlot;
            if (hasNextSlot) {
              hasNextSlot = nextSlot.durationLeft === slotSize;
            }
          }
          if (hasNextSlot) {
            remainingDuration -= slotSize;
          } else {
            break;
          }
        }
        return remainingDuration <= 0;
      });
    });
    return returnValue;
  },

  getAvailableTimeSlots(providerProfile, duration, timeZone) {
    if (!providerProfile.opening) {
      return {};
    }
    const openingSlots = makeTimeSlotsFromOpeningHoursMinusDayOff(providerProfile, timeZone);
    const appointmentSlots = makeTimeSlotsFromAppointments(providerProfile.appointments, providerProfile.id, timeZone);
    const emptySlots = subtractTimeSlots(openingSlots, appointmentSlots);

    Object.keys(emptySlots).forEach((dateKey) => {
      const dateStr = dateKeyToDateStr(dateKey);
      emptySlots[dateKey] = emptySlots[dateKey].filter((slot) => {
        const slotMoment = moment.tz(`${dateStr} ${slot.time}`, timeZone);
        const nextSlotMoment = slotMoment.clone();
        let remainingDuration = duration;
        remainingDuration -= slot.durationLeft;
        // remainingDuration -= slotSize;
        if (remainingDuration > 0 && slot.durationLeft < slotSize) {
          return false;
        }
        while (remainingDuration > 0) {
          nextSlotMoment.add(slotSize, 'minutes');
          const nextSlotDateKey = nextSlotMoment.format('YMMDD');
          let hasNextSlot = null;
          if (emptySlots[nextSlotDateKey]) {
            const nextSlot = emptySlots[nextSlotDateKey].find((s) => s.time === nextSlotMoment.format('HH:mm'));
            hasNextSlot = !!nextSlot;
            if (hasNextSlot) {
              hasNextSlot = nextSlot.durationLeft === slotSize;
            }
          }
          if (hasNextSlot) {
            remainingDuration -= slotSize;
          } else {
            break;
          }
        }
        return remainingDuration <= 0;
      });
    });
    return emptySlots;
  },

  mergeMultipleProviderTimeSlots(availableSlotsList) {
    let retval = {};
    Object.keys(availableSlotsList).forEach((providerId) => {
      retval = addAvailableSlots(retval, availableSlotsList[providerId]);
    });
    return retval;
  },

  convertTimeslotsTimezone(timeSlots, fromTimezone, toTimezone) {
    const convertedTimeSlots = {};

    Object.keys(timeSlots).forEach((dateKey) => {
      const timeSlotArr = timeSlots[dateKey];
      const dateStr = dateKeyToDateStr(dateKey);
      timeSlotArr.forEach((timeSlot) => {
        const fromMoment = moment.tz(`${dateStr} ${timeSlot.time}`, fromTimezone);
        const convertedMoment = moment.tz(fromMoment.unix() * 1000, toTimezone);
        const convertedDateKey = convertedMoment.format('YMMDD');
        const convertedTime = convertedMoment.format('HH:mm');
        const convertedSlot = {
          time: convertedTime,
          providers: timeSlot.providers.slice(),
          durationLeft: timeSlot.durationLeft,
        };
        if (!convertedTimeSlots[convertedDateKey]) {
          convertedTimeSlots[convertedDateKey] = [];
        }
        addSlotObjToSlotArray(convertedSlot, convertedTimeSlots[convertedDateKey]);
      });
    });
    return convertedTimeSlots;
  },

  convertPeriodsTimeZone(periodArr, fromTimezone, toTimezone) {
    const resultArr = [];

    periodArr.forEach((periodObj) => {
      const convertedPeriodObj = {};
      const convertedStartMoment = moment.tz(periodObj.start, fromTimezone).tz(toTimezone);
      convertedPeriodObj.start = convertedStartMoment.format('Y-MM-DD HH:mm:ss');

      if (periodObj.end) {
        const convertedEndMoment = moment.tz(periodObj.end, fromTimezone).tz(toTimezone);
        convertedPeriodObj.end = convertedEndMoment.format('Y-MM-DD HH:mm:ss');
      } else {
        convertedPeriodObj.end = periodObj.end;
      }

      dateUtil.daysOfWeek().forEach((dayOfWeekKey, index) => {
        const subperiodArr = periodObj[dayOfWeekKey];
        if (subperiodArr) {
          subperiodArr.forEach((subperiod) => {
            const subperiodStartMoment = moment.tz(fromTimezone);
            subperiodStartMoment.day(index);
            setTimeToMoment(subperiod.start, subperiodStartMoment);
            const convertedSubperiodStartMoment = moment.tz(subperiodStartMoment.unix() * 1000, toTimezone);
            const subperiodEndMoment = moment.tz(fromTimezone);
            subperiodEndMoment.day(index);
            setTimeToMoment(subperiod.end, subperiodEndMoment);
            const convertedSubperiodEndMoment = moment.tz(subperiodEndMoment.unix() * 1000, toTimezone);
            const startDayKey = dateUtil.dayOfWeekKeyForMoment(convertedSubperiodStartMoment);
            let endDayKey = dateUtil.dayOfWeekKeyForMoment(convertedSubperiodEndMoment);
            const convertedSubperiodStartTime = convertedSubperiodStartMoment.format('HH:mm');
            let convertedSubperiodEndTime = convertedSubperiodEndMoment.format('HH:mm');
            // If end at midnight
            if (convertedSubperiodEndTime === '00:00' && startDayKey !== endDayKey) {
              endDayKey = startDayKey;
              convertedSubperiodEndTime = '24:00';
            }
            if (!convertedPeriodObj[startDayKey]) {
              convertedPeriodObj[startDayKey] = [];
            }
            if (!convertedPeriodObj[endDayKey]) {
              convertedPeriodObj[endDayKey] = [];
            }
            if (startDayKey === endDayKey) {
              convertedPeriodObj[startDayKey].push({
                start: convertedSubperiodStartTime,
                end: convertedSubperiodEndTime,
              });
            } else {
              // Split subperiods that overlap days
              convertedPeriodObj[startDayKey].push({
                start: convertedSubperiodStartTime,
                end: '24:00',
              });
              convertedPeriodObj[endDayKey].splice(0, 0, {
                start: '00:00',
                end: convertedSubperiodEndTime,
              });
            }
          });
        }
      });

      dateUtil.daysOfWeek().forEach((dayOfWeekKey) => {
        if (convertedPeriodObj[dayOfWeekKey]) {
          const mergedSubperiodArr = [];
          const convertedSubperiodArr = convertedPeriodObj[dayOfWeekKey];
          let subperiodIndex = 0;
          while (subperiodIndex < convertedSubperiodArr.length) {
            const startTime = convertedSubperiodArr[subperiodIndex].start;
            let endTime = convertedSubperiodArr[subperiodIndex].end;
            let subsequentIndex = subperiodIndex + 1;
            while (subsequentIndex < convertedSubperiodArr.length) {
              const subsequentStartTime = convertedSubperiodArr[subsequentIndex].start;
              if (endTime === subsequentStartTime) {
                endTime = convertedSubperiodArr[subsequentIndex].end;
                subsequentIndex += 1;
              } else {
                break;
              }
            }
            subperiodIndex = subsequentIndex;
            mergedSubperiodArr.push({
              start: startTime,
              end: endTime,
            });
          }
          convertedPeriodObj[dayOfWeekKey] = mergedSubperiodArr.slice();
          convertedPeriodObj[dayOfWeekKey].sort((a, b) => a.start.localeCompare(b.start));
        }
      });
      resultArr.push(convertedPeriodObj);
    });
    return resultArr;
  },

  getLocalTimeZone() {
    return localTimeZone();
  },

  setLocalTimeZone(timezone) {
    localStorage.setItem('timezone', timezone);
  },

  getTimeZoneOffsetString(context) {
    const timeInstance = moment.tz(localTimeZone());
    return context.$t('common.time_zone_offset', {
      offset: timeInstance.format('Z'),
    });
  },

  mergeAdjacentSlots(timeSlotsList) {
    const retval = {};
    Object.keys(timeSlotsList).forEach((dateKey) => {
      const periodArr = [];
      let startMoment = null;
      let endMoment = null;
      const dateStr = dateKeyToDateStr(dateKey);
      let slots = timeSlotsList[dateKey];
      slots = slots.slice().sort((a, b) => a.time.localeCompare(b.time));

      slots.forEach((aSlot) => {
        if (!endMoment) {
          startMoment = moment(`${dateStr} ${aSlot.time}`);
          endMoment = startMoment.clone();
          endMoment.add(slotSize, 'minutes');
        } else if (aSlot.time === endMoment.format('HH:mm')) {
          endMoment.add(slotSize, 'minutes');
        } else {
          periodArr.push({
            startTime: startMoment.format('HH:mm'),
            endTime: endMoment.format('HH:mm'),
          });
          startMoment = moment(`${dateStr} ${aSlot.time}`);
          endMoment = startMoment.clone();
          endMoment.add(slotSize, 'minutes');
        }
      });
      if (startMoment && endMoment) {
        periodArr.push({
          startTime: startMoment.format('HH:mm'),
          endTime: endMoment.format('HH:mm'),
        });
      }
      startMoment = null;
      endMoment = null;
      periodArr.forEach((aPeriod) => {
        if (aPeriod.endTime === '00:00') {
          aPeriod.endTime = '24:00';
        }
      });
      if (periodArr.length > 0) {
        retval[dateStr] = periodArr;
      }
    });
    return retval;
  },

  clearInvalidSubperiodsFromPeriodIntervals(periodArr, timeZone) {
    periodArr.forEach((aPeriod) => {
      if (aPeriod.end) {
        const endDateMoment = moment.tz(aPeriod.end, timeZone);
        if (endDateMoment.format('HH:mm') === '00:00') {
          endDateMoment.subtract(1, 'minutes');
        }
        setTimeToMoment('00:00', endDateMoment);
        const startDateMoment = moment.tz(aPeriod.start, timeZone);
        setTimeToMoment('00:00', startDateMoment);
        const dayCount = endDateMoment.diff(startDateMoment, 'days') + 1;
        if (dayCount < 7) {
          const dayItr = startDateMoment.clone();
          dayItr.add(dayCount, 'days');
          for (let dayIndex = 0; dayIndex < 7 - dayCount; dayIndex += 1) {
            const dayKey = dateUtil.dayOfWeekKeyForMoment(dayItr);
            aPeriod[dayKey] = [];
            dayItr.add(1, 'days');
          }
        }
      }
    });
  },

  mergePeriodsWithSameIntervals(periodArr) {
    const mergedPeriods = [];

    periodArr.forEach((aPeriod) => {
      let existingPeriod = mergedPeriods.find(
        (aMergedPeriod) => aMergedPeriod.start === aPeriod.start && aMergedPeriod.end === aPeriod.end
      );
      if (!existingPeriod) {
        existingPeriod = {
          start: aPeriod.start,
          end: aPeriod.end,
        };
        mergedPeriods.push(existingPeriod);
      }

      dateUtil.daysOfWeek().forEach((dayKey) => {
        if (aPeriod[dayKey]) {
          const subperiodsToAdd = aPeriod[dayKey];
          if (!existingPeriod[dayKey]) {
            existingPeriod[dayKey] = [];
          }
          subperiodsToAdd.forEach((aSubperiod) => {
            existingPeriod[dayKey].push({
              start: aSubperiod.start,
              end: aSubperiod.end,
            });
          });
        }
      });
    });
    return mergedPeriods;
  },

  collapseAdjacentSubperiodsInPeriods(periodArr, timeZone) {
    periodArr.forEach((aPeriod) => {
      const dateItr = moment.tz(timeZone);
      for (let dayIndex = 0; dayIndex < 7; dayIndex += 1) {
        dateItr.day(dayIndex);
        const dayKey = dateUtil.dayOfWeekKeyForMoment(dateItr);
        if (aPeriod[dayKey]) {
          // Split to small slots
          const slots = [];
          const subperiods = aPeriod[dayKey];

          subperiods.forEach((aSubperiod) => {
            const startMoment = dateItr.clone();
            setTimeToMoment(aSubperiod.start, startMoment);
            const endMoment = startMoment.clone();
            setTimeToMoment(aSubperiod.end, endMoment);
            const timeItr = startMoment.clone();
            while (timeItr.diff(endMoment) < 0) {
              const aSlot = {
                hour: timeItr.format('HH'),
                minute: timeItr.format('mm'),
                timeString: timeItr.format('HH:mm'),
              };

              const isNew = !slots.some((obj) => obj.timeString === aSlot.timeString);
              if (isNew) {
                slots.push(aSlot);
              }
              timeItr.add(slotSize, 'minutes');
            }
          });
          // Sort small slots
          slots.sort((a, b) => a.timeString.localeCompare(b.timeString));
          // Merge small slots back to subperiods
          const subperiodArr = [];
          let subperiodStartMoment = null;
          let subperiodEndMoment = null;
          const subperiodDateStr = dateItr.format('Y-MM-DD');
          slots.forEach((aSlot) => {
            if (!subperiodEndMoment) {
              subperiodStartMoment = moment(`${subperiodDateStr} ${aSlot.timeString}`);
              subperiodEndMoment = subperiodStartMoment.clone();
              subperiodEndMoment.add(slotSize, 'minutes');
            } else if (aSlot.timeString === subperiodEndMoment.format('HH:mm')) {
              subperiodEndMoment.add(slotSize, 'minutes');
            } else {
              subperiodArr.push({
                startTime: subperiodStartMoment.format('HH:mm'),
                endTime: subperiodEndMoment.format('HH:mm'),
              });
              subperiodStartMoment = moment(`${subperiodDateStr} ${aSlot.timeString}`);
              subperiodEndMoment = subperiodStartMoment.clone();
              subperiodEndMoment.add(slotSize, 'minutes');
            }
          });
          if (subperiodStartMoment && subperiodEndMoment) {
            subperiodArr.push({
              startTime: subperiodStartMoment.format('HH:mm'),
              endTime: subperiodEndMoment.format('HH:mm'),
            });
          }
          subperiodStartMoment = null;
          subperiodEndMoment = null;
          aPeriod[dayKey] = subperiodArr.map((aSubperiod) => {
            let subPeriodEndTime = aSubperiod.endTime;
            if (subPeriodEndTime === '00:00') {
              subPeriodEndTime = '24:00';
            }
            return {
              start: aSubperiod.startTime,
              end: subPeriodEndTime,
            };
          });
        }
      }
    });
  },

  trimIntervalForPeriods(periodArr, timeZone) {
    periodArr.forEach((aPeriod) => {
      // Trim start and end date
      const periodStartMoment = moment.tz(aPeriod.start, timeZone);
      let periodStartDateString = periodStartMoment.format('Y-MM-DD');
      let periodStartTimeString = periodStartMoment.format('HH:mm');
      for (let periodDayItr = 0; periodDayItr < 7; periodDayItr += 1) {
        const periodStartDayKey = dateUtil.dayOfWeekKeyForMoment(periodStartMoment);
        if (aPeriod[periodStartDayKey]) {
          const subperiods = aPeriod[periodStartDayKey];
          if (subperiods.length > 0) {
            periodStartDateString = periodStartMoment.format('Y-MM-DD');
            const firstSubperiodTimeString = subperiods[0].start;
            if (firstSubperiodTimeString.localeCompare(periodStartTimeString) > 0) {
              periodStartTimeString = firstSubperiodTimeString;
            }

            aPeriod.start = `${periodStartDateString} ${periodStartTimeString}`;
            break;
          }
        }
        periodStartMoment.add(1, 'days');
        periodStartTimeString = '00:00';
      }
      if (aPeriod.end) {
        const periodEndMoment = moment.tz(aPeriod.end, timeZone);
        let periodEndTimeString = periodEndMoment.format('HH:mm');
        if (periodEndTimeString === '00:00') {
          periodEndMoment.subtract(1, 'minutes');
          periodEndTimeString = '24:00';
        }
        let periodEndDateString = periodEndMoment.format('Y-MM-DD');
        for (let periodDayItr = 0; periodDayItr < 7; periodDayItr += 1) {
          const periodEndDayKey = dateUtil.dayOfWeekKeyForMoment(periodEndMoment);
          if (aPeriod[periodEndDayKey]) {
            const subperiods = aPeriod[periodEndDayKey];
            if (subperiods.length > 0) {
              periodEndDateString = periodEndMoment.format('Y-MM-DD');
              const lastSubperiodTimeString = subperiods[subperiods.length - 1].end;
              if (lastSubperiodTimeString.localeCompare(periodEndTimeString) < 0) {
                periodEndTimeString = lastSubperiodTimeString;
              }
              aPeriod.end = `${periodEndDateString} ${periodEndTimeString}`;
              break;
            }
          }
          periodEndMoment.subtract(1, 'days');
          periodEndTimeString = '24:00';
        }
      }
    });
  },

  isPeriodEmpty(period) {
    return !dateUtil.daysOfWeek().some((dayKey) => {
      if (period[dayKey]) {
        if (period[dayKey].length > 0) {
          return true;
        }
      }
      return false;
    });
  },

  scheduleList(provider, timezone) {
    const profile = provider; // get data from providerProfile
    const timeZone = timezone ? timezone : undefined;
    const timeSlotsList = this.getOpeningHoursMinusDayOff(profile, 'UTC');
    // console.log(timeSlotsList);

    // convert to local time
    const localTimeSlotsList = this.convertTimeslotsTimezone(timeSlotsList, 'UTC', this.getLocalTimeZone(timeZone));
    // console.log(localTimeSlotsList);

    // merge
    let scheduleList = this.mergeAdjacentSlots(localTimeSlotsList);

    return scheduleList;
  },
};
